module.exports = __webpack_public_path__ + "img/integralBG2.ac4f0f21.png";